// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2RbqX","label":"Slider_label__10j1r","container":"Slider_container__12uS0","slider":"Slider_slider__3lWTq","rangeValue":"Slider_rangeValue__18rpH"};